export const isLoggedIn = !!window.jwt;
